import { createAction, props } from "@ngrx/store";
import { MonitoringControllerGetAll$Params, MonitoringControllerGetOne$Params, MonitoringControllerCreate$Params, MonitoringControllerUpdate$Params, MonitoringControllerGetAllStatuses$Params, MonitoringControllerGetTimeline$Params, MonitoringControllerStatusWidget$Params, EventControllerCreate$Params, EventControllerGetAll$Params, EventControllerGetOne$Params, EventControllerUpdate$Params, EventStatusControllerGetAll$Params, CommentControllerCreate$Params, CommentControllerGetAll$Params, CommentControllerCreateInactive$Params, CommentControllerActivate$Params, CommentControllerCleanup$Params } from "../../../api/functions";
import { MonitoringItemList, MonitoringItem, MonitoringStatusItemList, MonitoringStatusHistoryItemList, EventItem, EventItemList, EventStatusItemList, CommentItem, CommentListForMonitoring, EmptyResponse } from "../../../api/models";
import { ILoaderActionPayload } from "../models/loader.model";


export const monitoringActions = {
    // findAll
    load: createAction('load/monitoring', props<MonitoringControllerGetAll$Params>()),
    done: createAction(
        'load/monitoring/done',
        props<{ state: ILoaderActionPayload; data?: MonitoringItemList }>(),
    ),

    // findOne
    loadOne: createAction('load/monitoring/load-one', props<MonitoringControllerGetOne$Params>()),
    doneOne: createAction(
        'load/monitoring/done-one',
        props<{ state: ILoaderActionPayload; data?: MonitoringItem }>(),
    ),

    // create
    createOne: createAction('monitoring/create-one', props<MonitoringControllerCreate$Params>()),
    createOneDone: createAction(
        'monitoring/create-one/done',
        props<{ state: ILoaderActionPayload; data?: MonitoringItem }>(),
    ),
    createOneSetState: createAction(
        'monitoring/create-one/set-state',
        props<{ state: ILoaderActionPayload }>(),
    ),

    // update
    updateOne: createAction('monitoring/update-one', props<MonitoringControllerUpdate$Params>()),
    updateOneDone: createAction(
        'monitoring/update-one/done',
        props<{ state: ILoaderActionPayload; data?: MonitoringItem }>(),
    ),
    updateOneSetState: createAction(
        'monitoring/update-one/set-state',
        props<{ state: ILoaderActionPayload }>(),
    ),

    // statuses list
    monitoringStatusesLoad: createAction(
        'monitoring/statuses/load',
    ),
    monitoringStatusesDone: createAction(
        'monitoring/statuses/done',
        props<{ state: ILoaderActionPayload; data?: MonitoringStatusItemList }>(),
    ),

    // timeline
    timelineLoad: createAction(
        'monitoring/timeline/load',
        props<MonitoringControllerGetTimeline$Params>(),
    ),
    timelineDone: createAction(
        'monitoring/timeline/done',
        props<{ state: ILoaderActionPayload; data?: MonitoringStatusHistoryItemList }>(),
    ),

    // status widget
    statusWidgetLoad: createAction(
        'monitoring/status-widget/load',
        props<MonitoringControllerStatusWidget$Params>(),
    ),
    statusWidgetDone: createAction(
        'monitoring/status-widget/done',
        props<{ state: ILoaderActionPayload; data?: number }>(),
    ),
    // findAll events
    eventsLoad: createAction('monitoring/events/load', props<EventControllerGetAll$Params>()),
    eventsDone: createAction(
        'monitoring/events/done',
        props<{ state: ILoaderActionPayload; data?: EventItemList }>(),
    ),

    // findOne event
    eventLoadOne: createAction(
        'monitoring/events/load-one',
        props<EventControllerGetOne$Params>(),
    ),
    eventDoneOne: createAction(
        'monitoring/events/done-one',
        props<{ state: ILoaderActionPayload; data?: EventItem }>(),
    ),

    // create event
    eventCreateOne: createAction(
        'monitoring/events/create-one',
        props<EventControllerCreate$Params>(),
    ),
    eventCreateOneDone: createAction(
        'monitoring/events/create-one/done',
        props<{ state: ILoaderActionPayload; data?: EventItem }>(),
    ),
    eventCreateOneSetState: createAction(
        'monitoring/events/create-one/set-state',
        props<{ state: ILoaderActionPayload }>(),
    ),

    // update event
    eventUpdateOne: createAction(
        'monitoring/events/update-one',
        props<EventControllerUpdate$Params>(),
    ),
    eventUpdateOneDone: createAction(
        'monitoring/events/update-one/done',
        props<{ state: ILoaderActionPayload; data?: EventItem }>(),
    ),
    eventUpdateOneSetState: createAction(
        'monitoring/events/update-one/set-state',
        props<{ state: ILoaderActionPayload }>(),
    ),

    // event statuses
    eventStatusesLoad: createAction(
        'monitoring/events/statuses/load',
    ),
    eventStatusesDone: createAction(
        'monitoring/events/statuses/done',
        props<{ state: ILoaderActionPayload; data?: EventStatusItemList }>(),
    ),
    //comment
    commentsLoad: createAction(
        'monitoring/comments/load',
        props<CommentControllerGetAll$Params>(),
    ),
    commentsDone: createAction(
        'monitoring/comments/done',
        props<{ state: ILoaderActionPayload; data?: CommentListForMonitoring }>(),
    ),


    commentCreateOne: createAction(
        'monitoring/comments/create-one',
        props<CommentControllerCreate$Params>(),
    ),
    commentCreateOneDone: createAction(
        'monitoring/comments/create-one/done',
        props<{ state: ILoaderActionPayload; data?: CommentItem }>(),
    ),
    commentCreateOneSetState: createAction(
        'monitoring/comments/create-one/set-state',
        props<{ state: ILoaderActionPayload }>(),
    ),


    //gestione di creazione del commento con il file
    commentCrateActiveFalseLoad: createAction(
        'comment/create-active-false/load',
        props<CommentControllerCreateInactive$Params>(),
    ),
    commentCrateActiveFalseDone: createAction(
        'comment/create-active-false/done',
        props<{ state: ILoaderActionPayload; data?: CommentItem }>(),
    ),

    commentUpdateToActiveTrueLoad: createAction(
        'comment/update-to-true/load',
        props<CommentControllerActivate$Params>(),
    ),
    commentUpdateToActiveTrueDone: createAction(
        'comment/update-to-true/done',
        props<{ state: ILoaderActionPayload; data?: CommentItem }>(),
    ),

    commentUpdateToActiveTrueSetState: createAction(
        'comment/update-to-true/set-state',
        props<{ state: ILoaderActionPayload }>(),
    ),

    commentCheckForFilesLoad: createAction(
        'comment/check-files/load',
        props<CommentControllerCleanup$Params>(),
    ),
    commentCheckForFilesDone: createAction(
        'comment/check-files/done',
        props<{ state: ILoaderActionPayload; data?: EmptyResponse }>(),
    ),
};